import { render, staticRenderFns } from "./CndFgtsView.vue?vue&type=template&id=5d5cb0e2&scoped=true&"
import script from "./CndFgtsView.vue?vue&type=script&lang=js&"
export * from "./CndFgtsView.vue?vue&type=script&lang=js&"
import style0 from "./CndFgtsView.vue?vue&type=style&index=0&id=5d5cb0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5cb0e2",
  null
  
)

export default component.exports